export default __webpack_public_path__ + "static/media/bg_en.91b339ac.png";